import { useTranslation } from 'react-i18next';
import { CartBar } from './cartBar';

export interface BottomCartBarProps {
  barText?: string;
  open?: () => void;
  isPurchase?: boolean;
  isDisabled?: boolean;
  price?: number;
  hideBadge?: boolean;
}

export function BottomCartBar(props: BottomCartBarProps) {
  const { t } = useTranslation();
  const { isPurchase = false, isDisabled = false } = props;
  const barText = props.barText ?? (isPurchase ? t('payment:pay') : t('payment:cart'));

  return (
    <CartBar
      className="app-bottom-bar"
      barText={barText}
      isPurchase={isPurchase}
      isDisabled={isDisabled}
      open={props.open}
      price={props.price}
      hideBadge={props.hideBadge}
    />
  );
}
